<ng-container *ngIf="(configReady$ | async) && (rows$ | async) !== null && !!(columns$ | async)">
	<cm-table-meta *ngIf="showTableMeta"></cm-table-meta>

	<div class="table-container">
		<table mat-table matSort [dataSource]="datasource" [trackBy]="trackBy">
			<caption *ngIf="config$ | async as config">
				<span *ngIf="config?.caption?.key; else captionDefaultOnly">
					{{ config.caption.defaultValue | cmLocalize: config.caption.key }}
				</span>
				<ng-template #captionDefaultOnly>
					{{ config?.caption?.defaultValue || 'Table' }}
				</ng-template>
			</caption>
			<ng-container [matColumnDef]="selectColumnName">
				<th mat-header-cell *matHeaderCellDef>
					<ng-container *ngIf="selection">
						<mat-checkbox
							(change)="$event ? masterToggle() : null"
							[checked]="selection.hasValue() && isAllSelected()"
							[indeterminate]="
								!selectionFilter && selection.hasValue() && !isAllSelected()
							">
							<span
								class="cdk-visually-hidden"
								cmLocalize="Core/System.Table.Label.SelectAll"
								>Select All</span
							>
						</mat-checkbox>
					</ng-container>
				</th>
				<td mat-cell *matCellDef="let row">
					<ng-container *ngIf="selection">
						<mat-checkbox
							(click)="$event.stopPropagation()"
							(change)="$event ? selection.toggle(row) : null"
							[checked]="selection.isSelected(row)">
						</mat-checkbox>
					</ng-container>
				</td>
			</ng-container>
			<ng-container *ngFor="let col of parsedColumns$ | async; trackBy: waiter.columnTrackBy">
				<ng-container *ngIf="!col.hidden" [matColumnDef]="col.field">
					<ng-container *matHeaderCellDef>
						<th
							*ngIf="col.sortable; else noSortHeader"
							mat-header-cell
							[mat-sort-header]="col.sortField"
							[ngStyle]="{
								width: col.width
									? col.width?.value?.toString() + col.width.unit
									: 'auto'
							}"
							[matTooltip]="col.label | cmLocalize: col.localizationKey"
							[attr.aria-hidden]="col.type === 'action'">
							<ng-container
								*ngTemplateOutlet="
									col.headerTpl && headerTpls && headerTpls[col.headerTpl]
										? headerTpls[col.headerTpl]
										: defaultHeader;
									context: { $implicit: col }
								">
							</ng-container>
						</th>
						<ng-template #noSortHeader>
							<th
								mat-header-cell
								[ngStyle]="{
									width: col.width
										? col.width?.value?.toString() + col.width.unit
										: 'auto'
								}"
								[attr.aria-hidden]="col.type === 'action'">
								<ng-container
									*ngTemplateOutlet="
										col.headerTpl && headerTpls && headerTpls[col.headerTpl]
											? headerTpls[col.headerTpl]
											: defaultHeader;
										context: { $implicit: col }
									">
								</ng-container>
							</th>
						</ng-template>
					</ng-container>
					<td
						mat-cell
						*matCellDef="let element"
						[style.width]="col.width?.value?.toString() || 'auto'"
						[ngStyle]="{
							width: col.width
								? col.width?.value?.toString() + col.width.unit
								: 'auto'
						}">
						<ng-container
							*ngTemplateOutlet="
								cellTpls && cellTpls[col.cellTpl]
									? cellTpls[col.cellTpl]
									: defaultCell;
								context: { $implicit: element, col: col }
							">
						</ng-container>
					</td>
					<ng-container *ngIf="hasSummary$ | async">
						<td
							mat-footer-cell
							*matFooterCellDef
							[style.width]="col.width?.value?.toString() || 'auto'"
							[ngStyle]="{
								width: col.width
									? col.width?.value?.toString() + col.width.unit
									: 'auto'
							}">
							<ng-container *ngIf="summary$ | async as summary">
								{{ summary[col.field] || '' }}
							</ng-container>
						</td>
					</ng-container>
				</ng-container>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns$ | async"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns$ | async"></tr>
			<ng-container *ngIf="hasSummary$ | async">
				<tr mat-footer-row *matFooterRowDef="displayedColumns$ | async"></tr>
			</ng-container>
			<tr class="mat-row" *matNoDataRow>
				<td [attr.colspan]="(displayedColumns$ | async)?.length || 100">
					<span class="no-data" cmLocalize="Core/System.Table.Content.NoData"
						>No data to show</span
					>
				</td>
			</tr>
		</table>
	</div>
</ng-container>

<nav
	[attr.aria-label]="'Pagination' | cmLocalize: 'Core/System.Table.Title.PaginationLabel'"
	[hidden]="!datasource?.data?.length">
	<mat-paginator
		[pageSizeOptions]="waiter?.config?.pageOptions"
		[pageSize]="waiter?.config?.pageSize"
		showFirstLastButtons>
	</mat-paginator>
</nav>

<ng-template #defaultHeader let-col>
	<span *ngIf="col.label" [cmLocalize]="col.localizationKey" [default]="col.label"></span>
</ng-template>

<ng-template #defaultCell let-element let-col="col">
	<cm-new-table-cell [col]="col" [element]="element"> </cm-new-table-cell>
</ng-template>
